import { useContext } from 'react';

import { ApiContext } from 'src/contexts/ApiContext';

const useApi = () => {
  return useContext(ApiContext);
};

export default useApi;
